export const reportFields = {
    sales: [
        { key: 'saleDate', label: 'Sale Date' },
        { key: 'childId', label: 'Child ID' },
        { key: 'productName', label: 'Product Name' },
        { key: 'category', label: 'Category' },
        { key: 'founderName', label: 'Sold By' },
        { key: 'perUnitCostMYR', label: 'Cost (RM)' },
        { key: 'sellingPriceMYR', label: 'Revenue (RM)' },
        { key: 'totalProfit', label: 'Profit (RM)' }
    ],
    inventory: [
        { key: 'childId', label: 'Child ID' },
        { key: 'itemName', label: 'Item Name' },
        { key: 'category', label: 'Category' },
        { key: 'size', label: 'Size' },
        { key: 'color', label: 'Color' },
        { key: 'perUnitCostMYR', label: 'Cost (RM)' },
        { key: 'sellingPriceMYR', label: 'Price (RM)' },
        { key: 'status', label: 'Status' },
        { key: 'parentReadableId', label: 'Parent Batch ID' }
    ],
    product_overview: [
        // Parent Fields
        { key: 'productId', label: 'Parent ID' },
        { key: 'parentItemName', label: 'Parent Name' },
        { key: 'parentCategory', label: 'Parent Category' },
        { key: 'parentTotalItems', label: 'Batch Total Items' },
        // CORRECTED: This field was already here, but now it's confirmed.
        { key: 'parentPerUnitCostMYR', label: 'Batch Avg. Cost (RM)' },
        // Child Fields
        { key: 'childId', label: 'Child ID' },
        { key: 'childItemName', label: 'Child Item Name' },
        { key: 'childStatus', label: 'Child Status' },
        // ADDED: The sold date is now an option for this report
        { key: 'soldDate', label: 'Sold Date' },
        { key: 'childSize', label: 'Child Size' },
        { key: 'childColor', label: 'Child Color' },
        { key: 'childPerUnitCostMYR', label: 'Child Cost (RM)' },
        { key: 'childSellingPriceMYR', label: 'Child Price (RM)' },
        { key: 'childProfitMYR', label: 'Child Profit (RM)' }
    ]
};